import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5e8478be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid w-full grid-cols-4 gap-8" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Nom du personnel "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Prénom "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_6 = { class: "flex flex-col" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Adresse Email "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_8 = { class: "flex flex-col" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("N° Téléphone "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Adresse de localisation "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_12 = { class: "flex flex-col" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Nombre d'enfants "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_14 = { class: "flex flex-col" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode(" Relevé d'identité bancaire "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Date de naissance "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_18 = { class: "flex flex-col" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Sexe "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (congés)")
], -1))
const _hoisted_20 = { class: "flex flex-col" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Pièce d'identification "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Statut Matrimonial"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode(" Fonction de Responsabilité"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_26 = { class: "sticky top-0 flex flex-col justify-between" }
const _hoisted_27 = { class: "flex flex-col" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "w-10 h-10 bg-center bg-no-repeat bg-cover",
  style: {"background-image":"url(/media/icons/camera-profil.svg)"}
}, null, -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "",
  id: ""
}, "Modifier", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  type: "file",
  name: "",
  id: "fileProfile",
  class: "hidden"
}, null, -1))
const _hoisted_31 = [
  _hoisted_28,
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = { class: "flex flex-col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Date d'embauche "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_34 = { class: "flex flex-col" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Salaire "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_36 = { class: "flex flex-col" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Matricule "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_38 = { class: "flex flex-col" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Nom de la banque "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_40 = { class: "flex flex-col" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Numéro de compte "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_42 = { class: "flex flex-col" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Numéro de permis"),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_44 = { class: "flex flex-col" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Type de permis "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_46 = { class: "flex flex-col" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-300" }, [
  /*#__PURE__*/_createTextVNode("Date d'expiration "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500" }, " (*)")
], -1))
const _hoisted_48 = { class: "sticky bottom-0 flex flex-row items-end justify-center space-x-2" }

import { ref, onMounted, inject, onBeforeMount, watch } from "vue";
	import api from "@/api";
	import rules from "@/rules";
	import { validateAll } from "@/validator";
	import useNotyf from "@/composable/useNotyf";
	import { getAllVehicles } from "@/services/global";
	import { currentStation } from "@/state/api/userState";
	import { updateRecapilationInfoIfNecessary } from "@/services/global/prerequisitesService";

	
export default /*#__PURE__*/_defineComponent({
  __name: 'NewStaff',
  setup(__props) {

	const isLoading = ref(false);
	const notify = useNotyf();
	const activeView = ref(inject("activeView"));
	const getAllPersonals: any = inject("getAllPersonals");
	const style = ref(
		"border rounded-lg border-color grid grid-cols-3 col-span-3 gap-4 bg-[#141d27]"
	);
	const identityTypeCardData = ref<any>([]);
	const maritalStatusData = ref<any>([]);
	const vehiclesData = ref<any>([]);
	const vehicleSelected = ref<any>();
	const responsabilityFunctionData = ref<any>([]);
	const staffData = ref<any>({

		name: "",
		lastname: "",
		email: "",
		phone: "",
		address: "",
		bank_name: "",
		account_number: "",
		matricule: "",

		rib_path: "",

		birth_date: "",
		gender: "",
		hiring_date: "",
		nbr_children: 0,
		salary: "",
		photo_bin: "",
		photo_path: "",

		license_number: "",
		licence_type: "",
		licence_exp_date: "",

		city: 1,

		identity_type_card: 1,
		marital_status: maritalStatusData.value[0]?.key ?? null,
		responsability_function: null,

		vehicles: [],

		roaming_personnal: 0,
	});
	const validations = ref<any>({
		name: {
			value: staffData,
			validator: (value: any) => rules.global.userName.test(value.name),
			msg: {
				error: "Le nom doit contenir au moins 3 caractères",
			},
		},
		lastname: {
			value: staffData,
			validator: (value: any) => rules.global.userName.test(value.lastname),
			msg: {
				error: "Le nom doit contenir au moins 3 caractères",
			},
		},
		email: {
			value: staffData,
			validator: (value: any) => rules.global.email.test(value.email),
			msg: {
				error: "L'e-mail doit être valide",
			},
		},
		phone: {
			value: staffData,
			validator: (value: any) => rules.global.phone.test(value.phone),
			msg: {
				error: "Le téléphone doit être valide",
			},
		},
		address: {
			value: staffData,
			validator: (value: any) => rules.global.address.test(value.address),
			msg: {
				error: "L'adresse doit contenir au moins 5 caractères",
			},
		},
		bank_name: {
			value: staffData,
			validator: (value: any) => rules.global.shortText.test(value.bank_name),
			msg: {
				error: "Le nom de la banque doit contenir au moins 3 caractères",
			},
		},
		account_number: {
			value: staffData,
			validator: (value: any) => rules.global.shortText.test(value.account_number),
			msg: {
				error: "Le numéro de compte doit contenir au moins 10 caractères",
			},
		},
		matricule: {
			value: staffData,
			validator: (value: any) => rules.global.shortText.test(value.matricule),
			msg: {
				error: "Le matricule doit contenir au moins 3 caractères",
			},
		},
		birth_date: {
			value: staffData,
			validator: (value: any) => rules.global.date.test(value.birth_date),
			msg: {
				error: "La date de naissance est invalide",
			},
		},
		hiring_date: {
			value: staffData,
			validator: (value: any) => rules.global.date.test(value.hiring_date),
			msg: {
				error: "La date d'embauche est invalide",
			},
		},
		nbr_children: {
			value: staffData,
			validator: (value: any) => rules.global.number.test(value.nbr_children),
			msg: {
				error: "Le RIB est invalide",
			},
		},
		salary: {
			value: staffData,
			validator: (value: any) => rules.global.number.test(value.salary),
			msg: {
				error: "Le salaire doit être un nombre valide",
			},
		},
		// rib_path: {
		// 	value: staffData,
		// 	validator: (value: any) => value.rib_path != "", // rules.global.shortText.test(value.rib_path),
		// 	msg: {
		// 		error: "Le RIB est requis",
		// 	},
		// },
		license_number: {
			value: staffData,
			validator: (value: any) => rules.global.shortText.test(value.license_number),
			msg: {
				error: "Le numéro de permis doit contenir au moins 3 caractères",
			},
		},
		licence_type: {
			value: staffData,
			validator: (value: any) => value.licence_type != "",
			msg: {
				error: "Le type de permis doit contenir au moins 3 caractères",
			},
		},
		licence_exp_date: {
			value: staffData,
			validator: (value: any) => rules.global.date.test(value.licence_exp_date),
			msg: {
				error: "La date d'expiration du permis est invalide",
			},
		},
		city: {
			value: staffData,
			validator: (value: any) => rules.global.number.test(value.city) && value.city != null,
			msg: {
				error: "La ville est requise",
			},
		},
		identity_type_card: {
			value: staffData,
			validator: (value: any) => value.identity_type_card != null,
			msg: {
				error: "Le type de pièce d'identité est requis",
			},
		},
		marital_status: {
			value: staffData,
			validator: (value: any) => value.marital_status != '',
			msg: {
				error: "La situation matrimoniale est requise",
			},
		},
		responsability_function: {
			value: staffData,
			validator: (value: any) => value.responsability_function != null,
			msg: {
				error: "La fonction de responsabilité est requise",
			},
		},
	});

	watch(
		() => vehicleSelected.value,
		() => {
			staffData.value.vehicles.push(vehicleSelected.value);
		}
	);

	/**
	 * Functions
	 */
	const createStaff = async (filter?: any, page?: any) => {
		if (validateAll(validations.value)) {
			isLoading.value = true;
			await api()
				.stations.users.personal.create(staffData.value, currentStation.value?.key)
				.then(async (res: any) => {
					activeView.value = "list";
					// Force "Tous le Personnel" so the freshly-created row is
					// guaranteed to be visible (and avoids hitting a stale
					// filter uuid that may 422). The parent's defensive
					// fallback in `getAllPersonals` handles the unknown-uuid
					// case too, but this is the cleaner UX.
					await getAllPersonals("__all__");
					updateRecapilationInfoIfNecessary("driver");
					isLoading.value = false;
				})
				.catch((err: any) => {
					console.log(err);
					isLoading.value = false;
					notify.error("Une erreur s'est produite. Réessayez.");
				});
		} else {
			console.log("Create Staff Lost");
		}
	};

	const getIdentityTypeCardData = async (filter?: any, page?: any) => {
		// isLoading.value = true;
		await api()
			.others.identityTypeCard.getAll()
			.then((res: any) => {
				console.log("res: ", res.data);
				identityTypeCardData.value = res.data.map((t: any) => {
					return { key: t.id, value: t.label };
				});
				// isLoading.value = false;
			})
			.catch((err: any) => {
				console.log(err);
				// isLoading.value = false;
			});
	};

	const getMaritalStatusData = async (filter?: any, page?: any) => {
		// isLoading.value = true;
		await api()
			.others.maritalStatus.getAll()
			.then((res: any) => {
				console.log("res: ", res.data);
				maritalStatusData.value = res.data.map((t: any) => {
					return { key: t.uuid, value: t.label };
				});
				// isLoading.value = false;
			})
			.catch((err: any) => {
				console.log(err);
				// isLoading.value = false;
			});
	};

	const getResponsabilityFunctionData = async (filter?: any, page?: any) => {
		// isLoading.value = true;
		await api()
			.others.responsabilityFunction.getAll()
			.then((res: any) => {
				responsabilityFunctionData.value = res.data.map((t: any) => {
					return { key: t.uuid, value: t.label };
				});
				// isLoading.value = false;
			})
			.catch((err: any) => {
				console.log(err);
				// isLoading.value = false;
			});
	};

	function resetFields() {
		staffData.value.name = "";
		staffData.value.lastname = "";
		staffData.value.email = "";
		staffData.value.phone = "";
		staffData.value.address = "";
		staffData.value.bank_name = "";
		staffData.value.account_number = "";
		staffData.value.matricule = "";
		staffData.value.birth_date = "";
		staffData.value.hiring_date = "";
		staffData.value.nbr_children = "";
		staffData.value.salary = "";
		staffData.value.photo_bin = "";
		staffData.value.photo_path = "";
		staffData.value.rib_path = "";
		staffData.value.license_number = "";
		staffData.value.licence_type = "";

		staffData.value.licence_exp_date = "";

		staffData.value.city = 0;
		staffData.value.identity_type_card = 0;
		staffData.value.marital_status = 0;
		staffData.value.responsability_function = 0;
	}

	const openFileBrowser = () => {
		document.getElementById("fileProfile")?.click();
	};

	const removeVehicle = (index: number) => {
		staffData.value.vehicles.splice(index, 1); // Suppression d'un seul element a^ partir de index
	};

	const getData = async () => {
		await getIdentityTypeCardData();
		await getMaritalStatusData();
		await getResponsabilityFunctionData();
		vehiclesData.value = await getAllVehicles(null, null, false);
	};

	onBeforeMount(async () => {
		getData();
	});

return (_ctx: any,_cache: any) => {
  const _component_InputTag = _resolveComponent("InputTag")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_FieldSetTag = _resolveComponent("FieldSetTag")!
  const _component_ButtonTag = _resolveComponent("ButtonTag")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_FieldSetTag, {
      styleField: style.value,
      styleLegend: "bg-[#2a3144] rounded-lg",
      title: "Informations Personnelles"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : Paul J.",
            type: "text",
            onModel: _cache[0] || (_cache[0] = (e) => staffData.value.name = e),
            value: staffData.value.name,
            error: validations.value.name.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : Jamo",
            type: "text",
            onModel: _cache[1] || (_cache[1] = (e) => staffData.value.lastname = e),
            value: staffData.value.lastname,
            error: validations.value.lastname.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : abc@email.com",
            type: "email",
            onModel: _cache[2] || (_cache[2] = (e) => staffData.value.email = e),
            value: staffData.value.email,
            error: validations.value.email.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _hoisted_9,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : +237 650000000",
            type: "tel",
            onModel: _cache[3] || (_cache[3] = (e) => staffData.value.phone = e),
            value: staffData.value.phone,
            error: validations.value.phone.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : Avenu AX",
            type: "text",
            onModel: _cache[4] || (_cache[4] = (e) => staffData.value.address = e),
            value: staffData.value.address,
            error: validations.value.address.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : 5",
            type: "number",
            onModel: _cache[5] || (_cache[5] = (e) => staffData.value.nbr_children = e),
            value: staffData.value.nbr_children.toString(),
            error: validations.value.nbr_children.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : Avenu AX",
            type: "file",
            onModel: _cache[6] || (_cache[6] = (e) => staffData.value.rib_path = e),
            errorr: "validations.rib_path.message"
          })
        ]),
        _createElementVNode("div", _hoisted_16, [
          _hoisted_17,
          _createVNode(_component_InputTag, {
            type: "date",
            onModel: _cache[7] || (_cache[7] = (e) => staffData.value.birth_date = e),
            value: staffData.value.birth_date,
            error: validations.value.birth_date.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _hoisted_19,
          _createVNode(_component_SelectTag, {
            placeholder: "Sélectionner le sexe",
            onModel: _cache[8] || (_cache[8] = (e) => staffData.value.gender = e.key),
            selected: staffData.value.gender,
            data: JSON.stringify([{ key: 'M', value: 'Masculin' }, { key: 'F', value: 'Féminin' }])
          }, null, 8, ["selected", "data"])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_component_SelectTag, {
            placeholder: "Sélectionner un Type de Pièce",
            onModel: _cache[9] || (_cache[9] = (e) => staffData.value.identity_type_card = e.key),
            vvalue: "staffData.identity_type_card",
            selected: staffData.value.identity_type_card,
            error: validations.value.identity_type_card.message,
            data: JSON.stringify(identityTypeCardData.value)
          }, null, 8, ["selected", "error", "data"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _hoisted_23,
          _createVNode(_component_SelectTag, {
            placeholder: "Sélectionner un statut",
            onModel: _cache[10] || (_cache[10] = (e) => staffData.value.marital_status = e.key),
            vvalue: "staffData.marital_status",
            error: validations.value.marital_status.message,
            selected: staffData.value.marital_status,
            data: JSON.stringify(maritalStatusData.value)
          }, null, 8, ["error", "selected", "data"])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_SelectTag, {
            placeholder: "Sélectionner un poste",
            onModel: _cache[11] || (_cache[11] = (e) => staffData.value.responsability_function = e.key),
            error: validations.value.responsability_function.message,
            selected: staffData.value.responsability_function,
            vvalue: "staffData.responsability_function",
            data: JSON.stringify(responsabilityFunctionData.value)
          }, null, 8, ["error", "selected", "data"])
        ])
      ]),
      _: 1
    }, 8, ["styleField"]),
    _createElementVNode("div", _hoisted_26, [
      _createElementVNode("div", _hoisted_27, [
        _createVNode(_component_FieldSetTag, {
          styleField: "border rounded-lg border-color",
          styleLegend: "rounded-lg",
          title: "Photo de Profil"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "w-full h-[250px] bg-center bg-no-repeat bg-cover rounded-xl group",
              style: {"background-image":"url(/media/images/thumbnail-profil.svg)"}
            }, [
              _createElementVNode("div", {
                onClick: openFileBrowser,
                class: "flex-col items-center justify-center hidden w-full h-full space-y-2 cursor-pointer group-hover:flex hover:bg-opacity-50 rounded-xl hover:bg-black"
              }, _hoisted_31)
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_FieldSetTag, {
      styleField: style.value,
      styleLegend: "bg-[#2a3144] rounded-lg",
      title: "Informations Professionnelles"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createVNode(_component_InputTag, {
            type: "date",
            onModel: _cache[12] || (_cache[12] = (e) => staffData.value.hiring_date = e),
            value: staffData.value.hiring_date,
            error: validations.value.hiring_date.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_34, [
          _hoisted_35,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : 500 000",
            type: "number",
            onModel: _cache[13] || (_cache[13] = (e) => staffData.value.salary = e),
            value: staffData.value.salary.toString(),
            error: validations.value.salary.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_36, [
          _hoisted_37,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : AV56620S",
            type: "text",
            onModel: _cache[14] || (_cache[14] = (e) => staffData.value.matricule = e),
            value: staffData.value.matricule,
            error: validations.value.matricule.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_38, [
          _hoisted_39,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : BANK AFRIQUE",
            type: "text",
            onModel: _cache[15] || (_cache[15] = (e) => staffData.value.bank_name = e),
            value: staffData.value.bank_name,
            error: validations.value.bank_name.message
          }, null, 8, ["value", "error"])
        ]),
        _createElementVNode("div", _hoisted_40, [
          _hoisted_41,
          _createVNode(_component_InputTag, {
            placeholder: "Ex : Avenu AX",
            type: "text",
            onModel: _cache[16] || (_cache[16] = (e) => staffData.value.account_number = e),
            value: staffData.value.account_number,
            error: validations.value.account_number.message
          }, null, 8, ["value", "error"])
        ])
      ]),
      _: 1
    }, 8, ["styleField"]),
    (staffData.value.responsability_function == '9b88bbff-b54f-463e-8a6a-e3887598246a')
      ? (_openBlock(), _createBlock(_component_FieldSetTag, {
          key: 0,
          styleField: style.value,
          styleLegend: "bg-[#2a3144] rounded-lg",
          title: "Permis de Conduire"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_42, [
              _hoisted_43,
              _createVNode(_component_InputTag, {
                placeholder: "Ex : Avenu AX",
                type: "text",
                onModel: _cache[17] || (_cache[17] = (e) => staffData.value.license_number = e),
                value: staffData.value.license_number,
                error: validations.value.license_number.message
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createVNode(_component_InputTag, {
                placeholder: "Ex : B",
                type: "text",
                onModel: _cache[18] || (_cache[18] = (e) => staffData.value.licence_type = e),
                value: staffData.value.licence_type.toString(),
                error: validations.value.licence_type.message
              }, null, 8, ["value", "error"])
            ]),
            _createElementVNode("div", _hoisted_46, [
              _hoisted_47,
              _createVNode(_component_InputTag, {
                type: "date",
                onModel: _cache[19] || (_cache[19] = (e) => staffData.value.licence_exp_date = e),
                value: staffData.value.licence_exp_date,
                error: validations.value.licence_exp_date.message
              }, null, 8, ["value", "error"])
            ])
          ]),
          _: 1
        }, 8, ["styleField"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_48, [
      _createVNode(_component_ButtonTag, {
        label: "Réinitiliser les champs",
        styleLabel: "text-sm text-red-500 group-hover:text-white",
        css: "group border bg-transparent border-red-500 text-white px-6 py-2 hover:bg-red-500 w-full active:bg-red-400  focus:outline-none ",
        onClick: _cache[20] || (_cache[20] = () => resetFields())
      }),
      _createVNode(_component_ButtonTag, {
        label: "Créer",
        loader: isLoading.value,
        "text-loading": 'Création en cours...',
        css: "bg-[#219152] border-secondary text-white px-6 py-2 hover:bg-[#167841] w-full active:bg-[#219152]  focus:outline-none ",
        onClick: createStaff
      }, null, 8, ["loader"])
    ])
  ]))
}
}

})